import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import MainPagetitle from '../../layouts/MainPagetitle';
import VoucherService from '../../api/services/VoucherService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import moment from 'moment';
import swal from "sweetalert";
import { downloadExcel } from 'react-export-table-to-excel';
const VoucherListing = () => {
    const navigate = useNavigate();
    const [voucher, setVoucher] = useState([]);

    const [isLoading, setisloading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = voucher.slice(firstIndex, lastIndex);
    const npage = Math.ceil(voucher.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    useEffect(() => {
        if (localStorage.getItem("admintoken")) {
            getVoucher();
        }
        else {
            navigate('/')
        }
    }, []);
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    function changeCPage(id) {
        setCurrentPage(id);
    }

    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
    const getVoucher = async () => {
        try {
            let blogList = await VoucherService.Voucherlisting().json();
            setVoucher(blogList.data);
            setisloading(false);
        } catch (error) {

        }
    };
    const handlePaidStatus = async (e) => {
        e.preventDefault();
        let id = e.target.id
        try {
            var userData = {
                "id": id,
            }
            let responseData = await VoucherService.updatepaidstatus(userData).json();
            //if (responseData.status === true) {
            alert('Updated!!!')
            getVoucher();
            //}
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    }
    const handleUsedStatus = async (e) => {
        e.preventDefault();
        let id = e.target.id
        try {
            var userData = {
                "id": id,
            }
            let responseData = await VoucherService.updateStatus(userData).json();
            //if (responseData.status === true) {
            alert('Updated!!!')
            getVoucher();
            //}
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    }
    const updatechecktatus = async (e) => {
        e.preventDefault();
        let userid = e.target.id
        try {
            var userData = {
                id: userid
            }
            let responseData = await VoucherService.updatecheckstatus(userData).json();
            let responseDataVoucher = await VoucherService.updateVoucherstatus(userid).json();
            if (responseData.status === true || responseDataVoucher.status == true) {

                swal("Updated!!!").then((updatecheckstatus) => {
                    if (updatecheckstatus) {
                        getVoucher();
                        window.location.reload();
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    }
    const header = [
        "Checked",
        "Name",
        "Email",
        "Phone Number",
        "Voucher Title",
        "Voucher Code",
        "Status",
        "Billing User Name",
        "Billing Email",
        "Billing Amount",
        "Pays Cash (COD)",
        "Payment Status",
        "Date of Birth",
        "Street",
        "Address Addition",
        "Zip",
        "City",
        "Country",
        "VAT ID",
        "Company",
    ];
    const tableData = voucher.map((row, index) =>
        header.map((nw, i) =>
            [nw === "Checked" ? row.is_checked == 1 ? "Checked" : "Not Checked" : '',
            nw === "Name" ? row.first_last_name : '',
            nw === "Email" ? row.email : '',
            nw === "Phone Number" ? row.phone : '',
            nw === "Voucher Title" ? row.voucher_title : '',
            nw === "Voucher Code" ? row.voucher_code : '',
            nw === "Status" ? row.is_used == 1 ? "Used" : "Valid" : '',
            nw === "Billing User Name" ? row.billing_name : '',
            nw === "Billing Email" ? row.billing_email : '',
            nw === "Billing Amount" ? row.price : '',
            nw === "Pays Cash (COD)" ? row.is_cod == 1 ? "Yes" : "No" : '',
            nw === "Payment Status" ? row.is_paid == 1 ? "paid" : "Unpaid" : '',
            nw === "Date of Birth" ? row.dob ? moment(row.dob).format('DD.MM.YYYY') : '' : '',
            nw === "Street" ? row.street : '',
            nw === "Address Addition" ? row.address_addition : '',
            nw === "Zip" ? row.zip_code : '',
            nw === "City" ? row.city : '',
            nw === "Country" ? row.country : '',
            nw === "VAT ID" ? row.vat_id : '',
            nw === "Company" ? row.company_name : '']
        )
    )
    function useDownloadExcel() {
        downloadExcel({
            fileName: "Voucher Listing",
            sheet: "Voucher Listing",
            tablePayload: {
                header,
                body: tableData
            },
        });
    }
    const handleDelete = async (e) => {

        try {
            let responseData = await VoucherService.Voucherdestroy(e).json()
            if (responseData.status === true) {
                swal("Voucher Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getVoucher();
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message)
            }
        }
    }
    return (
        <>
            <MainPagetitle mainTitle="Manage Voucher" pageTitle={'Manage Voucher'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0"> Manage Voucher</h4>
                                        <button onClick={useDownloadExcel} className="btn btn-primary btn-sm ms-1"> Export Excel </button>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>Checked</th>
                                                    <th>First & Last Name</th>
                                                    <th>Email</th>
                                                    <th>Phone Number</th>
                                                    <th>Voucher Title</th>
                                                    <th>Voucher Code</th>
                                                    <th>Status</th>
                                                    <th>Billing User Name</th>
                                                    <th>Billing Email</th>
                                                    <th>Billing Amount</th>
                                                    <th>Pays Cash (COD)</th>
                                                    <th>Payment Status</th>
                                                    <th>Date of Birth</th>
                                                    <th>Street</th>
                                                    <th>Address Addition</th>
                                                    <th>Zip</th>
                                                    <th>City</th>
                                                    <th>Country</th>
                                                    <th>VAT ID</th>
                                                    <th>Company</th>
                                                    <th style={{ textAlign: 'left' }}><strong >Action</strong></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {records.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="products">
                                                                <h6>{index + 1}</h6>
                                                            </div>
                                                        </td>
                                                        <td>{item.is_checked == 0 || item.ischecked == 1 ? 
                                                            <span className="btn btn-danger btn-sm ms-1">Not Checked</span> :
                                                             <span className="btn btn-success btn-sm ms-1">Checked</span>}
                                                             <Link id={item.id} onClick={updatechecktatus}>   Change?  </Link>
                                                        </td>
                                                        <td>
                                                            <div className="products">
                                                                <h6>{item.first_last_name}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="products">
                                                                <h6>{item.email}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <h6>{item.phone}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.voucher_title}</h6>
                                                        </td>

                                                        <td>
                                                            <h6>{item.voucher_code}</h6>
                                                        </td>

                                                        <td>
                                                            <h6>{item.is_used == 0 ? <span className="btn btn-success btn-sm ms-1">Valid</span> : <span className="btn btn-danger btn-sm ms-1">Used</span>}
                                                                <Link id={item.id} onClick={handleUsedStatus}> Change?</Link></h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.billing_name ? item.billing_name : '-'}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.billing_email ? item.billing_email : '-'}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.price}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.is_cod == 1 ? "Yes" : "No"}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.is_paid == 1 ? <span className="btn btn-success btn-sm ms-1">Paid</span> : <span className="btn btn-danger btn-sm ms-1">Unpaid</span>}</h6>
                                                            <Link id={item.id} onClick={handlePaidStatus}> Change?</Link>
                                                        </td>
                                                        <td>
                                                            <h6>{moment(item.dob).format('DD/MM/YYYY')}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.street ? item.street : "_"}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.address_addition ? item.address_addition : "_"}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.zip_code ? item.zip_code : "_"}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.city ? item.city : "_"}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.country ? item.country : "_"}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.vat_id ? item.vat_id : "_"}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.company_name ? item.company_name : "_"}</h6>
                                                        </td>
                                                        <td>
                                                            <Link
                                                                onClick={() =>
                                                                    swal({
                                                                        title: "Are you sure?",
                                                                        text: "Once deleted, you will not be able to recover this data!",
                                                                        icon: "warning",
                                                                        buttons: true,
                                                                        dangerMode: true,
                                                                    }).then((willDelete) => {
                                                                        if (willDelete) {
                                                                            (handleDelete(item.id));
                                                                        }
                                                                    })
                                                                }

                                                                className="btn btn-danger shadow btn-xs sharp"
                                                            >
                                                                <i className="fa fa-trash"></i>
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {voucher.length < lastIndex ? voucher.length : lastIndex}
                                                {" "}of {voucher.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default VoucherListing;